import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appAutofocus]',
    exportAs: 'appAutofocus',
    standalone: true
})
export class AutoFocusDirective implements AfterViewInit {
    get autofocus(): boolean {
        return this.#autofocus;
    }

    @Input('appAutofocus')
    set autofocus(autofocus: boolean | string) {
        this.#autofocus = coerceBooleanProperty(autofocus);
    }

    #autofocus = true;

    constructor(private readonly elementRef: ElementRef) {}

    ngAfterViewInit(): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(() => {
            // Needs to be inside promise to avoid ExpressionChangedAfterItHasBeenCheckedError
            if (this.autofocus) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                this.elementRef.nativeElement?.focus();
            }
        });
    }
}
